import request from '@/utils/request'

// 获取安徽省平台教材列表(教育云平台)
export function bookList(data) {
    return request({
        url: '/user/get/ahy/bookList',
        method: 'post',
        data:data
    })
}
// 获取安徽省平台拥有教材的出版社版本列表(教育云平台)
export function editionList() {
    return request({
        url: '/user/get/ahy/editionList',
        method: 'post',
    })
}
// 获取安徽省平台资源的预览地址(教育云平台)
export function getPreviewUrl(resId) {
    return request({
        url: '/user/get/ahy/getPreviewUrl?resId=' + resId,
        method: 'post',
    })
}
// 获取安徽省平台年级列表(教育云平台)
export function gradeList() {
    return request({
        url: '/user/get/ahy/gradeList',
        method: 'post',
    })
}
// 获取安徽省平台资源列表(教育云平台)
export function resourceList(data) {
    return request({
        url: '/user/get/ahy/resourceList',
        method: 'post',
        data: data
    })
}
// 获取安徽省平台学科列表(教育云平台)
export function subjectList() {
    return request({
        url: '/user/get/ahy/subjectList',
        method: 'post',
    })
}
// 安徽教育云开放平台认证接口
export function authentication(type, data, path) {
    return request({
        url: `/user/hero/ahy/authentication?${type}=${data}&wxUrl=${path}`,
        method: 'get',
    })
}
// 安徽教育云开放平台认证接口回调
export function callback() {
    return request({
        url: '/user/hero/ahy/authentication/callback',
        method: 'get',
    })
}
// 获取个人信息-全角色(教育云平台-个人信息)
export function info(data) {
    return request({
        url: '/user/edu/cloud/get/personal/info',
        method: 'post',
        data: data
    })
}


// WEBPACK FOOTER //
// ./src/api/province_Resource.js